import { InputCpfCnpj, InputDatePicker, InputPadrao, InputSwitch, InputTelefone, TextArea } from '../../../../components/Inputs'
import React, { useState, useEffect, useRef, useMemo, useDebugValue } from 'react'
import { Formik, Form } from "formik"
import { mostrarToast } from '../../../../components/Toasts'
import { BotaoPadrao } from '../../../../components/Botoes'
import { get, salvar, validar } from '../../../../util/AcessoApi'
import { Link, useParams } from "react-router-dom"
import { ajustarDadosTelefone, buscarCep, mensagens } from '../../../../util/Utilitarios'
import Yup, { validaCNPJ, validaCPF } from '../../../../util/Validacoes'
import '../../../../assets/css/ios-switch/clean-switch.css'
import 'react-circular-progressbar/dist/styles.css'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Atalho from '../../../../util/Atalho'
import { HeaderCadastro } from '../../../../components/Headers'
import { InputConselhoProfissional, InputEstado, InputMunicipio, InputPrestador, InputPrestadorConselho, InputTipoPessoa } from '../../../../components/InputsAutoComplete'
import { ModalDuasOpcoes } from '../../../../components/Modais'

const CadastroPrestador = (props) => {

    let { id } = useParams()
    let { idModal } = props
    const [dataTelefone, setDataTelefone] = useState([])
    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [validacao] = useState(Yup.object({
        prestador: Yup.object().required().nullable(),
        conselho_profissional: Yup.object().required().nullable(),
        estado: Yup.object().required().nullable(),
        numero_registro: Yup.string().required().nullable(),
    }))


    const manter = []

    const Submit = (values, propsFormik) => {
        setSalvando(true)

        values.fone = ajustarDadosTelefone(dataTelefone.length > 0 ? dataTelefone : values.telefone)

        salvar(
            values,
            '/atendimento/prestadorconselhoprof',
            (obj) => {
                if (props.modal) {
                    if (salvarENovo) {
                        propsFormik.resetForm({})
                        manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                        setSalvando(false)
                        setSalvarENovo(false)
                    }
                    else if (!idModal) {
                        props.setItemSelecionado({ value: obj.item_selecionado.value, label: obj.item_selecionado.label })
                        props.setShow && props.setShow(false)
                    }
                    else {

                        if (props.idTela && props.rotaTela) {
                            values.idTela = props.idTela
                            salvar(
                                values,
                                props.rotaTela, _ => {
                                    propsFormik.resetForm({})
                                    props.setShow && props.setShow(false)
                                    mostrarToast('sucesso', mensagens.sucesso)
                                },
                                (err) => { setSalvando(false); console.log('ERR ', err) })
                        }
                        // propsFormik.resetForm({})
                        // props.setShow && props.setShow(false)
                        // mostrarToast('sucesso', mensagens.sucesso)

                    }
                } else {
                    mostrarToast('sucesso', mensagens.sucesso)
                    if (salvarENovo) {
                        propsFormik.resetForm({})
                        // manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                        setSalvando(false)
                        setSalvarENovo(false)
                    }
                    else
                        props.history.push('/atendimento/prestadorconselhoprof/consulta')

                    setSalvando(false)
                }

            },

            (err) => {
                console.log('err: ', err);
                mostrarToast('erro', mensagens.erro)
                setSalvando(false)
            })
    }


    useEffect(_ => {
        if (props.modal && idModal)
            id = idModal
        if ((!props.modal && id) || idModal) {

            Promise.resolve(get(`/atendimento/prestadorconselhoprof/${id}`)).then(obj => {
                setValoresIniciais(obj)
                if (obj.fone)
                    setDataTelefone(obj.fone)
            })
        } else {
            setValoresIniciais({
                prestador: '',
                conselho_profissional: '',
                estado: '',
                numero_registro: '',
                // principal: false

            })
        }
    }, [id])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => (<Form>
                <div className={props.modal && props.modal || 'card mb-20'}>
                    <div className={props.modal || 'card-body'}>
                        <div className='row'>

                            <InputPrestadorConselho obrigatorio tamanho={!props.modal && 'col-sm-12 col-lg-4 col-xl-4'} classeTooltip={props.modal && 'tooltip-input-modal'} label="Prestador" name="prestador"
                                placeholder="Prestador" propsFormik={propsFormik} />
                            <InputConselhoProfissional obrigatorio tamanho={!props.modal && 'col-sm-12 col-lg-4 col-xl-2'} classeTooltip={props.modal && 'tooltip-input-modal'} label="Conselho Profissional" name="conselho_profissional"
                                placeholder="Conselho Profissional" propsFormik={propsFormik} />
                            <InputPadrao obrigatorio label='Número Registro' name='numero_registro' type='text' placeholder='Número Registro'
                                classeTooltip={'tooltip-input-modal'} tamanho={!props.modal && 'col-lg-2'} />
                            <InputEstado obrigatorio tamanho={!props.modal && 'col-sm-12 col-lg-2 col-xl-2'} classeTooltip={props.modal && 'tooltip-input-modal'} label="Estado" name="estado"
                                placeholder="Estado" propsFormik={propsFormik} />

                            {/* <InputSwitch label='Principal' disabled={false} propsFormik={propsFormik} quebrarLinha classeDiv='form-group ajusta-switch-operadora ' name='principal' size="md" tamanho={!props.modal && 'col-lg-1'} classeTooltip={props.modal && 'tooltip-input-modal'} /> */}



                        </div>
                    </div>
                </div>
                {!props.modal && <div className='separator mt-40 mb-5'></div>}
                <div className='direita container-botoes mb-3 group-salvar-novo'>
                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                    {(props.modal || !id) && (!props.rotaTela) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                </div>
            </Form>)}
        </Formik>
    );
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Atendimento</span>,
        () => <Link className='link-active' to={'/atendimento/prestadorconselhoprof/consulta'}>Prestador Conselho Profissional</Link>,
    ]
    return (<>
        {!props.modal && <HeaderCadastro titulo={"Cadastro Prestador Conselho Profissional"} link={links} />}
        <CadastroPrestador {...props} />
    </>
    )
}
export { CadastroPrestador }
export default Cadastro


